import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Brand {
  id: number;
  title: string;
}

interface Category {
  id: number;
  name: string;
}

interface FiltersListState {
  brands: Brand[] | null;
  categories: Category[] | null;
}

export const initialState: FiltersListState = {
  brands: null,
  categories: null,
};

export const filtersListSlice = createSlice({
  name: 'filtersList',
  initialState,
  reducers: {
    setFiltersList(
      state,
      action: PayloadAction<{
        brands: Brand[];
        categories: Category[];
      }>
    ) {
      state.brands = action.payload.brands;
      state.categories = action.payload.categories;
    },
  },
});

export const { setFiltersList } = filtersListSlice.actions;
